const locationLat = location => Number(location?.latNumber ?? location?.lat)
const locationLng = location => Number(location?.lngNumber ?? location?.lng)

export const getFirstLocationAtMarker = (markerLocation, locations) => {
  const lat = locationLat(markerLocation)
  const lng = locationLng(markerLocation)

  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return markerLocation
  }

  return (
    locations.find(location => {
      return locationLat(location) === lat && locationLng(location) === lng
    }) || markerLocation
  )
}
